module.exports = __webpack_public_path__ + "static/media/protectiveGear.b6737b0f.jpg";